import sortedUniq from "lodash/sortedUniq";
import React from "react";

import { alphabeticalSorter } from "~/tools/alphabetical-sorter";
import { sort } from "~/tools/sort";

import { Tag } from "../expandable-list/Tag";

export const SortedTagList: React.FC<{ items: ReadonlyArray<string> }> = ({ items }) => {
	const sortedUniqItems = React.useMemo(() => sortedUniq(sort(items, alphabeticalSorter)), [items]);

	return sortedUniqItems.map((item) => <Tag key={item} text={item} />);
};
